import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "plus--light",
  "use": "plus--light-usage",
  "viewBox": "0 0 16.681 16.681",
  "content": "<symbol viewBox=\"0 0 16.681 16.681\" id=\"plus--light\"><path d=\"M8.634 8.634v8.047l-.587-.008V8.641L.008 8.634 0 8.047h8.047V0l.587.007v8.047l8.04-.007.007.587H8.634z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/plus--light.svg
// module id = 181
// module chunks = 0